import { fullDateFormat } from '../lib/dateFormatter';

const buildEligibilityRequest = (builderServer, residenceHistory, campus) => {
  const {
    citizenshipCountries,
    residenceCountry,
    residenceState,
    currentResidenceStartDate,
    fullTimeJob,
    partTimeCourse,
    id: applicationId,
    countryOfHabitualResidenceCode: habitualResidenceCountryCode,
  } = builderServer;
  const { country: campusCountry, state: campusState } = campus;
  const residenceCountries = residenceHistory.map(item => item.countryCode);
  const now = new Date(Date.now());

  return {
    product: 'in_school',
    applicationId,
    ratoa: {
      country: residenceCountry,
      state: residenceState,
      startDate: currentResidenceStartDate,
      endDate: fullDateFormat(now),
    },
    citizenshipCountries,
    residenceCountries,
    loanSource: {
      country: campusCountry,
      state: campusState,
    },
    fullTimeJob,
    partTimeCourse,
    habitualResidenceCountryCode,
  };
};

export default buildEligibilityRequest;
